// import Attendance from "./Attendance";

export default {
  // component: Attendance,
  priority: 96,
  name: app.translate("نظر مدیر ماهیانه"),
  path: "ManagerOpinion",
  permissions: [
    "MonthlyManagerOpinion",
    "95370c95370cef2cd1c7e8aec8a2624db809b06009753fff9bf1a935d0ccfebd6aae6fef2cd1c7e8aec8a2624db809b06009753fff9bf1a935d0ccfebd6aae6f",
  ], // ["ReportsMenu", "DeviceListMenu", "DeviceChartMenu", "ClockingMenu", "WorkingHourMenu", "CalendarMenu"
  // ,"ShiftDefinitionMenu", "PositionsMenu", "WritMenu", "PolicyDefinitionMenu", "SettingDefinitionMenu", "StackRulesMenu", "StackHistoryMenu"],
  component: load(() =>
    import(/* webpackChunkName: "Writs" */ "./MonthlyManagerOpinion")
  ),
  icon: "av-timer",
  drawer: true,
  description: `نظر مدیر - نظر مدیر ماهیانه
  با استفاده از این ماژول مدیران میتوانند نظر خود را بروی عملکرد ماهانه پرسنل اعمال نمایند و مقادیر محاسبه شده‌ی ماموریت و مرخصی و اضافه کاری و ... را با توجه به نیاز خود تغییر دهند. در این شرایط معمولا گزارش طبق نظر مدیر تهیه میگردد و برای محاسبات حقوق لحاظ می گردد`,
};
